import { useBlockProps, RichText, InnerBlocks } from '@wordpress/block-editor';
// import Icon from '../Icon/index.jsx';

export default function save( { attributes } ) {
	const {
		blockID,
		itemTitle,
		itemTitleTag,
		activeIcon,
		inactiveIcon,
		itemContent,
	} = attributes;

	return (
		<div
			{ ...useBlockProps.save( {
				className: `block-${ blockID } alpha-accordion-item`,
			} ) }
			x-bind="accordionItem"
		>
			<div
				className="alpha-accordion-head"
				role="button"
				aria-controls="accordion-panel-1"
				x-bind="accordionHead"
			>
				<RichText.Content
					tagName={ itemTitleTag }
					value={ itemTitle }
				/>
				<div className="icon-area">
					<window.Icon
						name={ inactiveIcon?.iconName ?? 'chevron-down' }
						xBind="closeItem"
					/>
					<window.Icon
						name={ activeIcon?.iconName ?? 'chevron-up' }
						xBind="openItem"
					/>
				</div>
			</div>
			<div className="alpha-accordion-content" x-bind="accordionContent">
				<RichText.Content tagName="p" value={ itemContent } />
			</div>
		</div>
	);
}
